import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchConfigKeys } from "./api";
import type { ConfigKeysResponse } from "./api";

// Реестр конфиг-ключей `ConfigKey` — варианты для Select ключа и
// валидации значения на форме apply `config_update`. Org-scoped запрос
// (см. `src/query/scope.ts`); зеркало `useSupportedModels` под
// role_change.
export function useConfigKeys(): UseQueryResult<ConfigKeysResponse, Error> {
  return useOrgScopedQuery<ConfigKeysResponse>({
    key: ["self-improvement", "config-keys"],
    queryFn: () => fetchConfigKeys(),
    retry: false,
  });
}
